module.exports = __webpack_public_path__ + "static/media/profile.1d516aeb.svg";